import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  FormControlLabel,
  FormGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import COCDatePicker from "../../components/DateTimePicker/DateTimePicker";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import { Tab } from "react-bootstrap";
import MqttData from "../MqttData";
import { getAcConditioningRoomData } from "./services";

const Acconditioning = () => {
  const [topic, setTopic] = useState([
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:AC",
  ]);
  const [mqttData, setMqttData] = useState([]);
  const [showTime, setShowTime] = useState(false);
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [acRoomData, setAcRoomData] = useState([]);
  const dateFormat = "YYYY-MM-DD";
  const startDateFormat = dayjs(startDateReFormat).format(dateFormat);
  const endDateFormat = dayjs(endDateReFormat).format(dateFormat);

  const DateTimeFormat = (date) => {
    const Date_Time_Format = "YYYY-MM-DD HH:mm:ss";
    // console.log("YYYY-MM-DD hh:mm:ss",dayjs(date).format(Date_Time_Format))
    return dayjs(date).format(Date_Time_Format);
  };

  console.log("startDateReFormat", startDateReFormat);
  const initiallValue = {
    binNo: "",
    batchNo: "",
    Class: "",
    Size: "",
    Scre: "",
    cycleTime: "",
    cycleEndTime: "",
    totalTime: "",
    remainingTime: "",
    overTimeL: "",
    operator: "",
    shift: "",
    quantity: "",
  };
  const [searchText, setSearchText] = useState(initiallValue);
  const [debouncedSearchText, setDebouncedSearchText] = useState({});
  const [count, setCount] = useState(0);

  const navigate = useNavigate();
  const mergedArray = [].concat(...Object.values(mqttData));

  const tagValue = mergedArray.find(
    (item) => item.device_tag == "AC_ROOM_1_TEMP"
  );
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText); // Update the debounced searchText
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler); // Cleanup the timeout
    };
  }, [searchText]);
  const handleBack = () => {
    navigate("/gloves-tracking");
  };

  const handleToggleTime = () => {
    setShowTime(!showTime);
  };

  const handleStartDate = (newStartDate) => {
    console.log("newStartDate", newStartDate);
    setStartDateReFormat(newStartDate);
  };

  const handleEndDate = (newEndDate) => {
    if (showTime) {
      setEndDateReFormat(newEndDate);
    } else {
      setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
    }
  };

  const handleSearchData = (e) => {
    const { name, value } = e.target;
    setSearchText((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    // Initial call
    handleGetData();
    const interval = setInterval(() => {
      handleGetData();
    }, 60000);

    return () => clearInterval(interval);
  }, [
    debouncedSearchText,
    page,
    rowsPerPage,
    startDateReFormat,
    endDateReFormat,
    showTime,
  ]);

  const handleGetData = async () => {
    const searchParams = {
      search: searchText,
      page: page,
      rowsPerPage: rowsPerPage,
    };

    if (startDateReFormat && endDateReFormat) {
      if (showTime) {
        const StartDateTime = DateTimeFormat(startDateReFormat);
        const EndDateTime = DateTimeFormat(endDateReFormat);

        searchParams["start_datetime"] = StartDateTime;
        searchParams["end_datetime"] = EndDateTime;
      } else {
        searchParams["start_datetime"] = `${startDateFormat} 00:00:00`;
        searchParams["end_datetime"] = `${endDateFormat} 23:59:59`;
      }
    } else {
      searchParams["start_datetime"] = null;
      searchParams["end_datetime"] = null;
    }
    try {
      const resp = await getAcConditioningRoomData(searchParams);
      if (resp.status === 200 || resp.status === 201) {
        setAcRoomData(resp.data.results.payload);
        setCount(resp.data.count);
      }
    } catch (err) {
      setAcRoomData([]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div className="page-wraper">
      <MqttData
        topics={topic}
        setMqttTagData={setMqttData}
        // allData={allStationData}
      />
      <div className="page-header">
        <Link
          to="/gloves-tracking"
          className="page-back-btn"
          onClick={handleBack}
        >
          <ArrowBackIcon />
          <span style={{ width: "max-content" }}>AC Conditioning Room</span>
        </Link>
        <div className="d-flex align-items-center">
          <div className="live-temp" style={{ padding: "16px" }}>
            Live Temperature : {tagValue?.tagValue} °C
          </div>
          <FormGroup aria-label="position" row>
            <FormControlLabel
              className="time-picker no-margin-label"
              value="top"
              control={<Switch color="primary" checked={showTime} />}
              label="Time"
              labelPlacement="top"
              onChange={handleToggleTime}
            />
          </FormGroup>

          <COCDatePicker
            time={showTime}
            startDateReFormat={startDateReFormat}
            endDateReFormat={endDateReFormat}
            handleStartDate={handleStartDate}
            handleEndDate={handleEndDate}
            Start_Date_lable={"Start Date"}
            end_Date_lable={"End Date"}
          />
        </div>
      </div>
      <div className="table-responsive">
        <Table aria-label="Dipping parameter" className="AcTableData">
          <TableHead>
            <TableRow>
              <TableCell>Sr.No</TableCell>
              <TableCell>Bin No</TableCell>
              <TableCell>Batch No</TableCell>
              <TableCell>Class</TableCell>
              <TableCell>Size</TableCell>
              <TableCell>R.E/S.C</TableCell>
              <TableCell> Good Quantity</TableCell>
              <TableCell>Start Date Time</TableCell>
              <TableCell>End Date Time</TableCell>
              <TableCell>Total Time (hr)</TableCell>
              <TableCell>Remaining Time (hr)</TableCell>
              <TableCell>Overtime (hr)</TableCell>
              <TableCell>Operator</TableCell>
              <TableCell>Shift</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Sr.No"
                  // name="B_No"
                  // value={searchText.B_No}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Bin No"
                  name="binNo"
                  value={searchText.binNo}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Batch No"
                  name="batchNo"
                  value={searchText.batchNo}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Class"
                  name="Class"
                  value={searchText.Class}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Size"
                  name="Size"
                  value={searchText.Size}
                  onChange={handleSearchData}
                />
              </TableCell>
             
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="S.C"
                  name="Scre"
                  value={searchText.Scre}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="quantity"
                  name="quantity"
                  value={searchText.quantity}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Start Date Time"
                  name="cycleTime"
                  value={searchText.cycleTime}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="End Date Time"
                  name="cycleEndTime"
                  value={searchText.cycleEndTime}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Total Time"
                  name="totalTime"
                  value={searchText.totalTime}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Remaining Time"
                  name="remainingTime"
                  value={searchText.remainingTime}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Overtime"
                  name="overTimeL"
                  value={searchText.overTimeL}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Operator"
                  name="operator"
                  value={searchText.operator}
                  onChange={handleSearchData}
                />
              </TableCell>
              <TableCell className="search-table-row">
                <SearchIcon className="search-icon" />
                <input
                  type="search"
                  placeholder="Shift"
                  name="shift"
                  value={searchText.shift}
                  onChange={handleSearchData}
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="acCondition-body">
            {acRoomData?.map((row, index) => {
              return (
                <TableRow
                  className={
                    row.is_overtime == true ? "hover-acConditioning-data" : ""
                  }
                >
                  <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                  <TableCell>{row.bin_number}</TableCell>
                  <TableCell>{row.batch_type}</TableCell>
                  <TableCell>{row.class_name}</TableCell>
                  <TableCell>{row.size}</TableCell>

                  <TableCell>{row.sc_re}</TableCell>
                  <TableCell>
                    <Box
                      className={
                        row.good !== null && row.good !== undefined
                          ? "good-status"
                          : ""
                      }
                    >
                      {row.good !== null && row.good !== undefined
                        ? row.good
                        : ""}
                    </Box>
                  </TableCell>
                  <TableCell>
                    {row.start_date_time
                      ? dayjs(row.start_date_time).format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {row.process_end_time
                      ? dayjs(row.process_end_time).format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </TableCell>
                  <TableCell>{row.total_time}</TableCell>
                  <TableCell>{row.remaining_time}</TableCell>
                  <TableCell>{row.overtime}</TableCell>
                  <TableCell>{row.operator}</TableCell>
                  <TableCell>{row.shift_name}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        className="table-pagination"
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};
export default Acconditioning;
